export default __webpack_public_path__ + "media/images/icons/exclamation-triangle-solid-03d439fad5cc481899c705a5d87d337f.svg";